import React from "react";
import { Box, Typography, Grid, Paper, Button, Stack } from "@mui/material";
import WorkIcon from "@mui/icons-material/Work";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import SearchIcon from "@mui/icons-material/Search";
import PeopleIcon from "@mui/icons-material/People";
import { useAuth } from "../../auth/AuthContext";
import { useNavigate } from "react-router-dom";

export default function DashboardHome() {

  const {user} = useAuth();
  const navigate = useNavigate();
  // Later: fetch actual user details from AuthContext
  // const user = { name: "Aniket", role: "USER" }; // or HR

  return (
    <Box sx={{ p: 3 }}>
      {/* Welcome Section */}
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Welcome back, {user.name} 👋
      </Typography>
      <Typography variant="subtitle1" color="text.secondary" gutterBottom>
        Here’s a quick overview of your account
      </Typography>

      {/* Quick Stats */}
      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Paper sx={{ p: 3, textAlign: "center" }}>
            <UploadFileIcon fontSize="large" color="primary" />
            <Typography variant="h6">5</Typography>
            <Typography variant="body2" color="text.secondary">
              Resumes Uploaded
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper sx={{ p: 3, textAlign: "center" }}>
            <WorkIcon fontSize="large" color="success" />
            <Typography variant="h6">12</Typography>
            <Typography variant="body2" color="text.secondary">
              Jobs Available
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper sx={{ p: 3, textAlign: "center" }}>
            <SearchIcon fontSize="large" color="warning" />
            <Typography variant="h6">8</Typography>
            <Typography variant="body2" color="text.secondary">
              Matches Found
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper sx={{ p: 3, textAlign: "center" }}>
            <PeopleIcon fontSize="large" color="error" />
            <Typography variant="h6">3</Typography>
            <Typography variant="body2" color="text.secondary">
              Applications Made
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      {/* Quick Actions */}
      <Box sx={{ mt: 5 }}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Quick Actions
        </Typography>
        <Stack direction="row" spacing={2} flexWrap="wrap">
          {user.role === "USER" ? (
            <>
              <Button variant="contained" color="primary" onClick={()=>{navigate("/app/user/resume/upload")}}>
                Upload Resume
              </Button>
              <Button variant="outlined" color="success" onClick={()=>{navigate("/app/user/resume/shortlist")}}>
                Find Matching Jobs
              </Button>
              <Button variant="outlined" color="warning" onClick={()=>{navigate("/app/user/applications")}}>
                View Applications
              </Button>
            </>
          ) : (
            <>
              <Button variant="contained" color="primary" onClick={()=>{navigate("/app/hr/jobs/new")}}>
                Post a Job
              </Button>
              <Button variant="outlined" color="success" onClick={()=>{navigate("/app/jobs")}}>
                View Jobs
              </Button>
              <Button variant="outlined" color="warning" onClick={()=>{navigate("/app/hr/applications")}}>
                View Applications
              </Button>
            </>
          )}
        </Stack>
      </Box>

      {/* Recent Activity */}
      <Box sx={{ mt: 5 }}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Recent Activity
        </Typography>
        <Paper sx={{ p: 3 }}>
          <Typography variant="body1" gutterBottom>
            ✅ You applied for <b>Java Developer at Infosys</b>
          </Typography>
          <Typography variant="body1" gutterBottom>
            📂 You uploaded a new resume: <b>Resume_2025.pdf</b>
          </Typography>
          <Typography variant="body1">
            🔍 Found 3 new matches for your profile
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
}
